import React from "react";
import Icon from "components/AppIcon";
import { Link } from "react-router-dom";

export default function MetricCards({ onCardClick, activeCard, metrics: metricsProp }) {
  const cards = (metricsProp || []).map((m, index) => ({
    id: m.id || index + 1,
    title: m.title,
    value: m.value,
    unit: m.unit || "",
    change: m.change,
    changeType: m.changeType,
    icon: m.icon || "BarChart3",
    color: m.color || "#1E40AF",
    bgColor: m.bgColor || "#DBEAFE",
    description: m.description,
    breakdown: m.breakdown || [],
    linkTo: m.linkTo,
  }));

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
      {cards?.map((m) => {
        const isActive = activeCard === m?.id;
        return (
          <div
            key={m?.id}
            role="button"
            tabIndex={0}
            onClick={() => onCardClick(isActive ? null : m?.id)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") onCardClick(isActive ? null : m?.id);
            }}
            className="text-left rounded-xl border transition-all duration-200 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            style={{
              background: "var(--color-card)",
              borderColor: isActive ? m?.color : "var(--color-border)",
              boxShadow: isActive ? `0 0 0 2px ${m?.color}33` : "var(--shadow-md)",
              padding: "20px",
              cursor: "pointer",
            }}
            aria-pressed={isActive}
          >
            <div className="flex items-start justify-between mb-3">
              <div
                className="flex items-center justify-center rounded-lg"
                style={{ width: 40, height: 40, background: m?.bgColor }}
              >
                <Icon name={m?.icon} size={20} color={m?.color} strokeWidth={2} />
              </div>
              {m?.change && m?.change !== 'live' ? (
                <span
                  className="text-xs font-medium font-caption px-2 py-0.5 rounded-full"
                  style={{
                    background: m?.changeType === "positive" ? "#D1FAE5" : "#FEE2E2",
                    color: m?.changeType === "positive" ? "#059669" : "#DC2626",
                  }}
                >
                  {m?.change}
                </span>
              ) : null}
            </div>
            <div className="mb-1">
              <span
                className="font-heading font-bold"
                style={{ fontSize: "1.625rem", color: "var(--color-foreground)", lineHeight: 1.2 }}
              >
                {m?.value}
              </span>
              {m?.unit && (
                <span className="text-sm ml-1" style={{ color: "var(--color-text-secondary)" }}>
                  {m?.unit}
                </span>
              )}
            </div>
            <p className="font-caption text-sm font-semibold mb-1" style={{ color: "var(--color-foreground)" }}>
              {m?.title}
            </p>
            <p className="font-caption text-xs" style={{ color: "var(--color-text-secondary)" }}>
              {m?.description}
            </p>
            {isActive && (
              <div className="mt-3 pt-3 border-t" style={{ borderColor: "var(--color-border)" }}>
                {m?.breakdown?.map((b, i) => (
                  <div key={i} className="flex items-center justify-between mb-1.5">
                    <span className="font-caption text-xs" style={{ color: "var(--color-text-secondary)" }}>
                      {b?.label}
                    </span>
                    <div className="flex items-center gap-2">
                      <div className="w-16 h-1.5 rounded-full" style={{ background: "var(--color-muted)" }}>
                        <div
                          className="h-full rounded-full"
                          style={{ width: `${b?.pct}%`, background: m?.color }}
                        />
                      </div>
                      <span className="font-data text-xs font-medium" style={{ color: "var(--color-foreground)", minWidth: 32 }}>
                        {(b?.count || 0).toLocaleString("en-IN")}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {m?.linkTo && (
              <div className="mt-3 pt-3 border-t flex items-center justify-between"
                style={{ borderColor: "var(--color-border)" }}>
                <Link
                  to={m.linkTo}
                  className="flex items-center gap-1.5 font-caption text-xs font-semibold hover:underline"
                  style={{ color: m?.color }}
                >
                  View records
                  <Icon name="ArrowRight" size={12} color="currentColor" />
                </Link>
                <span className="font-caption text-xs" style={{ color: "var(--color-text-secondary)" }}>
                  {m?.linkLabel || ""}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}